<div>
  @if (courseModules$ | async; as courseModules) {

    @if (courseModules && courseModules.length > 0) {
      <div class="space-y-3">
        @for (module of courseModules; track $index) {
          <article class="lesson-module-card">
            <button
              type="button"
              class="lesson-module-toggle"
              [class.lesson-module-toggle-open]="openModuleIndex === $index"
              (click)="toggleModule($index)">
              <span class="lesson-module-title">{{ module.title }}</span>
              <span class="lesson-module-meta">
                <span class="lesson-module-count">{{ module.lessons?.length ?? 0 }}</span>
                <i class="fa-solid fa-chevron-down transition" [class.rotate-180]="openModuleIndex === $index"></i>
              </span>
            </button>

            @if (openModuleIndex === $index) {
              <div class="lesson-module-body">
                <div class="overflow-x-auto">
                  <table class="lesson-table">
                    <thead class="lesson-table-head">
                      <tr>
                        <th class="lesson-th">{{ 'general.actions' | translate }}</th>
                        <th class="lesson-th">{{ 'lesson.title' | translate }}</th>
                        <th class="lesson-th">{{ 'lesson.order' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (lesson of module.lessons ?? []; track lesson.id) {
                        <tr class="lesson-row">
                          <td class="lesson-actions-cell">
                            <div class="lesson-actions">
                              <button
                                class="lesson-action-btn lesson-action-btn-edit"
                                (click)="editLesson(lesson)"
                                [attr.aria-label]="'general.edit' | translate"
                                [title]="'general.edit' | translate">
                                <i class="fa-regular fa-pen-to-square"></i>
                              </button>
                              <button
                                class="lesson-action-btn lesson-action-btn-delete"
                                (click)="deleteLesson(lesson.id)"
                                [attr.aria-label]="'general.delete' | translate"
                                [title]="'general.delete' | translate">
                                <i class="fa-solid fa-trash-can"></i>
                              </button>
                            </div>
                          </td>
                          <td class="lesson-title-cell">{{ lesson.title }}</td>
                          <td class="lesson-order-cell">{{ lesson.order }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </article>
        }
      </div>
    }
  }

</div>
